import * as React from "react";

const Input = React.forwardRef(
  ({ className = "", type = "text", ...props }, ref) => {
    return (
      <input
        type={type}
        className={`flex h-10 w-full border border-neutral-200 bg-white px-4 py-2 text-sm font-light text-penta-black placeholder:text-penta-grey-medium focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-penta-mint focus-visible:border-penta-mint disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-200 ${className}`}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
